import {  useContext } from "react";
import {Text, Link, VStack, } from "native-base";
import { ACTIONS,  EVENTS, PAGETYPE, } from "../../constants";
import StyledButton from "../../components/Button";
import StyledOutlinedButton from "../../components/OutlinedButton";
import {useNavigate,useLocation} from "react-router-dom";
import { AppContext } from '../../context';
// import {fetchAnalyticsData} from '../utils/firebase/analytics';
function PinkHome(props) {
  const location = useLocation();
  const Pink = require("./logo.png");
  const MainImage = require("./main.png");
  const Main2Image = require("./main2.png");
  const navigate = useNavigate();
  const { getParams} = useContext(AppContext);

  const containerStyle = {
    width: '339px',
    height: '100px',
    //padding: '30px 113px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const imageStyle = {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'cover',
    marginTop:'28px'
  };

  const onSelect = (type) => {
    switch(type){
      case PAGETYPE.return:
        navigate(`${location.pathname}/${PAGETYPE.return}${location.search}`)
        window.gtag('event', EVENTS.RETURN, {
          'event_category': 'User Actions',
          'event_label': EVENTS.RETURN,
          'value': JSON.stringify({
            digitalId:getParams.digitalId,
            category:EVENTS.RETURN,
            styleId: getParams.styleId,
            style:getParams.style,
            lang:getParams.lang
          }) 
        });
        break;
      case PAGETYPE.care:
        navigate(`${location.pathname}/${PAGETYPE.care}${location.search}`)
        window.gtag('event', EVENTS.CARE, {
          'event_category': 'User Actions',
          'event_label': EVENTS.CARE,
          'value': JSON.stringify({
            digitalId:getParams.digitalId,
            category:EVENTS.CARE,
            styleId: getParams.styleId,
            style:getParams.style,
            lang:getParams.lang
          }) 
        });
        break;
      case PAGETYPE.upcycle:
          navigate(`${location.pathname}/${PAGETYPE.upcycle}${location.search}`)
          window.gtag('event', EVENTS.upcycle, {
            'event_category': 'User Actions',
            'event_label': EVENTS.upcycle,
            'value': JSON.stringify({
              digitalId:getParams.digitalId,
              category:EVENTS.upcycle,
              styleId: getParams.styleId,
              style:getParams.style,
              lang:getParams.lang
            }) 
          });
        break;
      case PAGETYPE.repair:
        navigate(`${location.pathname}/${PAGETYPE.repair}${location.search}`)
        window.gtag('event', EVENTS.REPAIR, {
          'event_category': 'User Actions',
          'event_label': EVENTS.REPAIR,
          'value': JSON.stringify({
            digitalId:getParams.digitalId,
            category:EVENTS.REPAIR,
            styleId: getParams.styleId,
            style:getParams.style,
            lang:getParams.lang
          }) 
        });
        break;
        case PAGETYPE.recycle:
        navigate(`${location.pathname}/${PAGETYPE.recycle}${location.search}`)
        window.gtag('event', EVENTS.RECYCLE, {
          'event_category': 'User Actions',
          'event_label': EVENTS.RECYCLE,
          'value': JSON.stringify({
            digitalId:getParams.digitalId,
            category:EVENTS.RECYCLE,
            styleId: getParams.styleId,
            style:getParams.style,
            lang:getParams.lang
          }) 
        });
        break;
      case PAGETYPE.resale:
          navigate(`${location.pathname}/${PAGETYPE.resale}${location.search}`)
          window.gtag('event', EVENTS.RESALE, {
            'event_category': 'User Actions',
            'event_label': EVENTS.RESALE,
            'value': JSON.stringify({
              digitalId:getParams.digitalId,
              category:EVENTS.RESALE,
              styleId: getParams.styleId,
              style:getParams.style,
              lang:getParams.lang
            }) 
          });
        break;
      case PAGETYPE.yourOutfits:
          navigate(`${location.pathname}/${PAGETYPE.yourOutfits}${location.search}`)
        break;
      case ACTIONS.OPEN_MAIL:
          window.location.href = `mailto:${location.pathname === '/a-new-sweden'? 'help@anewsweden.com' : location.pathname === '/la-makanerie'? 'contact@la-makanerie.com': 'elizabeth@hellomadi.com'} `
          window.gtag('event', EVENTS.HELP_AND_CONTACT, {
            'event_category': 'User Actions',
            'event_label': EVENTS.HELP_AND_CONTACT,
            'value': JSON.stringify({
              digitalId:getParams.digitalId,
              category:EVENTS.HELP_AND_CONTACT,
              styleId: getParams.styleId,
              style:getParams.style,
              lang:getParams.lang
            }) 
          });
        
        break;
      default:
        navigate(`${location.pathname}`)
        break;
    }
  }
  return (
    <>
        <>
          <VStack alignItems="center" justifyContent="center" py={"1"} paddingTop={"10px"} marginBottom={'20px'}>
          <a href={"https://www.hellomadi.co/"} target="_blank" rel="noopener noreferrer">
            <div style={{...containerStyle,width:'100%'}}>
              <img width={'100%'} src={Pink} alt="Responsive"  />
          </div>
          </a>
          </VStack>
          <VStack alignItems="center" px={"4"}>
          <img 
            width={'85%'}
            src={ MainImage} alt="Responsive" style={imageStyle} />
          </VStack>
          <VStack alignItems="center" marginTop={"30px"}>
          <img  src={Main2Image} alt="Responsive" style={imageStyle} />
          </VStack>
          <VStack alignItems="flex-start" px={4} py={4} space={4}>
            <Text 
             color={'black'}
             fontWeight={'300'}
             fontSize={'26px'} 
             fontFamily={'Unna'}
            >
              A table linen reinvented...
            </Text>
            <Text
             color={'black'}
             fontSize={'12px'} 
             fontFamily={'Unna'}
            >
              This vest was made from fabric dating back to the early 1900s, a pink crochet tablecloth. The fabric holds a special place in our hearts, as it has been passed down through generations by strong women, and now into a vest for another strong woman to wear proudly.
            </Text>
            <Link
              href={`${location.pathname}/history${location.search}`}
              width={"full"}>
              <Text 
               color={'black'}
               fontSize={'12px'} 
               fontFamily={'Unna'} >
                HISTORY & INSPIRATION BEHIND THE VEST →
              </Text>
            </Link>
          </VStack>

          <VStack
            alignItems="center"
            space={2}
            marginBottom={7}
            mx={4}
            
          >
              <StyledOutlinedButton
              fontSize={'20px'}
                fontFamily={'Unna'}
                onClick={()=>onSelect(PAGETYPE.yourOutfits)}
                backgroundColor="#EEA3AC"
                borderColor={ '#D9D9D9'}
                textColor={'black'}
                width="100%"
                height="54px"
                text={'YOUR OUTFITS'}
              />
              <StyledOutlinedButton
              fontSize={'20px'}
                fontFamily={'Unna'}
                backgroundColor="#EEA3AC"
                borderColor={ '#D9D9D9'}
                textColor={'black'}
                width="100%"
                height="54px"
                text={'CARE'}
                onClick={()=>onSelect(PAGETYPE.care)}
              />
          </VStack>
          <VStack alignItems="center" space={2} mx={4} marginBottom={5}>
              <StyledOutlinedButton
              fontSize={'20px'}
                fontFamily={'Unna'}
                onClick={()=>onSelect(PAGETYPE.repair)}
                backgroundColor="#EEA3AC"
                borderColor={ '#D9D9D9'}
                textColor={'black'}
                width="100%"
                height="54px"
                text={'REPAIR OR ALTER'}
              />
              <StyledOutlinedButton
              fontSize={'20px'}
                fontFamily={'Unna'}
                onClick={()=>onSelect(PAGETYPE.upcycle)}
                backgroundColor="#EEA3AC"
                borderColor={ '#D9D9D9'}
                textColor={'black'}
                width="100%"
                height="54px"
                text={'UPCYCLE'}
              />
            {/* </Link> */}
            {/* <Link
              href={`/la-makanerie/upcycle${location.search}`}
              width={"full"}
            > */}
              <StyledOutlinedButton
                fontFamily={'Unna'}
                fontSize={'20px'}
                onClick={()=>onSelect(PAGETYPE.recycle)}
                backgroundColor="#EEA3AC"
                borderColor={ '#D9D9D9'}
                textColor={'black'}
                width="100%"
                height="54px"
                text={'RECYCLE'}
              />
            {/* </Link> */}
            {/* <Link href="mailto:contact@la-makanerie.com" width={"full"}> */}
              <StyledButton
                fontFamily={'Unna'}
                fontSize={'20px'}
                onClick={()=> onSelect(ACTIONS.OPEN_MAIL)}
                text={'CUSTOMER ASSISTANCE'}
                backgroundColor="#9D7C07"
                borderColor={ '#D9D9D9'}
                textColor={'black'}
                width="100%"
                height="54px"
                hoverBackgroundColor="#FFFFFF"
              />
            {/* </Link> */}
          </VStack>
        </>
    </>
  );
}

export default PinkHome;
